// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerContainer":"Footer_footerContainer__yunXS","footerContent":"Footer_footerContent__E5RXg","footerText":"Footer_footerText__y-wf5"};